import { map } from 'rxjs/operators';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from './../_models/userSettings';
import { environment } from '../../../environments/environment';
import { configurationColumnTableFA } from '../../../assets/data/enum/configurationColumnTableFA';
import { configurationColumnTableStableLoads } from '../../../assets/data/enum/configurationColumnTableStableLoads';
import { configurationColumnTableLoads } from '../../../assets/data/enum/configurationColumnTableLoads';
import { configurationColumnTableStableA } from '../../../assets/data/enum/configurationColumnTableStableA';
import { ThemeConfig } from '../../../assets/data/enum/themeConfig';
import { SAASBRANDNAME } from '../../../assets/data/enum/saasBrandName.enum';
import { configurationColumnTableStableLoadsGRANLATTE } from '../../../assets/data/enum/configurationColumnTableStableLoadsGRANLATTE';
import { configurationColumnTableDA } from '../../../assets/data/enum/configurationColumnTableDa';
import { configurationColumnTableFAPioneerFields } from '../../../assets/data/enum/configurationColumnTableFAPioneerFields';

@Injectable()
export class UserSettingsService {
  defaultConfigurationColumnTableFA = configurationColumnTableFA;
  defaultConfigurationColumnTableDA = configurationColumnTableDA;
  defaultConfigurationColumnTableStableA = configurationColumnTableStableA;
  defaultConfigurationColumnTableStableLoads = configurationColumnTableStableLoads;
  defaultConfigurationColumnTableStableLoadsGRANLATTE =
    configurationColumnTableStableLoadsGRANLATTE;
  defaultConfigurationColumnTableLoads = configurationColumnTableLoads;
  defaultConfigurationColumnTablePioneerFields = configurationColumnTableFAPioneerFields;
  private apiBaseUrl = environment.apiBaseUrl;
  themeConfig = ThemeConfig;
  brand = SAASBRANDNAME;

  public configurationColumnTableFASignal = signal<any>(null);

  constructor(private http: HttpClient) {
    if (
      this.themeConfig.brand == this.brand.BARILLA ||
      this.themeConfig.brand == this.brand.IFARMS
    ) {
      delete this.defaultConfigurationColumnTableFA['checks'];
    }
  }

  saveUserSettings(activityUserId): Observable<UserSettings> {
    return this.http
      .post<UserSettings>(this.apiBaseUrl + 'api/private/v1/userSettings', activityUserId)
      .pipe(map((response) => response));
  }

  updateUserSettings(activityUserSettings): Observable<UserSettings> {
    return this.http
      .put<UserSettings>(
        this.apiBaseUrl + 'api/private/v1/userSettings/' + activityUserSettings.user.id,
        activityUserSettings
      )
      .pipe(map((response) => response));
  }

  getConfigurationColumnTableFA() {
    const tmpConfig = JSON.parse(localStorage.getItem('configurationColumnTable'));
    if (!tmpConfig || tmpConfig == null) {
      if (this.themeConfig.brand == this.brand.PIONEERFIELDS) {
        return this.defaultConfigurationColumnTablePioneerFields;
      } else {
        return this.defaultConfigurationColumnTableFA;
      }
    } else {
      return JSON.parse(localStorage.getItem('configurationColumnTable'));
    }
  }

  getConfigurationColumnTableDA() {
    const tmpConfig = JSON.parse(localStorage.getItem('configurationColumnTableDA'));
    if (!tmpConfig || tmpConfig == null) {
      return this.defaultConfigurationColumnTableDA;
    } else {
      return JSON.parse(localStorage.getItem('configurationColumnTableDA'));
    }
  }

  getConfigurationColumnTableStableLoads() {
    const tmpConfig = JSON.parse(localStorage.getItem('configurationColumnTableStableLoads'));
    if (!tmpConfig || tmpConfig == null) {
      return this.defaultConfigurationColumnTableStableLoads;
    } else {
      return JSON.parse(localStorage.getItem('configurationColumnTableStableLoads'));
    }
  }

  getConfigurationColumnTableStableLoadsGRANLATTE() {
    const tmpConfig = JSON.parse(localStorage.getItem('configurationColumnTableStableLoads'));
    if (!tmpConfig || tmpConfig == null) {
      return this.defaultConfigurationColumnTableStableLoadsGRANLATTE;
    } else {
      return JSON.parse(localStorage.getItem('configurationColumnTableStableLoads'));
    }
  }

  getConfigurationColumnTableLoads() {
    const tmpConfig = JSON.parse(localStorage.getItem('configurationColumnTableLoads'));
    if (!tmpConfig || tmpConfig == null) {
      return this.defaultConfigurationColumnTableLoads;
    } else {
      return JSON.parse(localStorage.getItem('configurationColumnTableLoads'));
    }
  }

  getConfigurationColumnTableStableA() {
    const tmpConfig = JSON.parse(localStorage.getItem('configurationColumnTableStableA'));
    if (!tmpConfig || tmpConfig == null) {
      return this.defaultConfigurationColumnTableStableA;
    } else {
      return JSON.parse(localStorage.getItem('configurationColumnTableStableA'));
    }
  }

  setConfigurationColumnTableFA(configurationColumnTable) {
    localStorage.setItem('configurationColumnTable', JSON.stringify(configurationColumnTable));
  }

  setConfigurationColumnTableStableA(configurationColumnTable) {
    localStorage.setItem(
      'configurationColumnTableStableA',
      JSON.stringify(configurationColumnTable)
    );
  }

  setConfigurationColumnTableStableLoads(configurationColumnTable) {
    localStorage.setItem(
      'configurationColumnTableStableLoads',
      JSON.stringify(configurationColumnTable)
    );
  }

  setConfigurationColumnTableLoads(configurationColumnTable) {
    localStorage.setItem('configurationColumnTableLoads', JSON.stringify(configurationColumnTable));
  }
}
